import type { CurrentThemesResponse } from '@apis/_themes'
import type { QueryClient } from 'react-query'
import { fetchInvoiceThemeId } from './fetchInvoiceThemeId'
import { pickInvoiceThemeIdFromCurrentThemes } from './pickInvoiceThemeId'

export type ThemeIdPort = {
  fromCache: (queryClient: QueryClient) => string | null
  fetch: () => Promise<string | null>
  fetchTimeoutMs: number
}

export const defaultThemeIdPort: ThemeIdPort = {
  fromCache: (queryClient) =>
    pickInvoiceThemeIdFromCurrentThemes(
      queryClient.getQueryData<CurrentThemesResponse>(['current_themes']),
    ),
  fetch: fetchInvoiceThemeId,
  fetchTimeoutMs: 3000,
}
